var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loader"},[_c('popup-base',[_c('div',{staticClass:"loader w-1/2 m-auto"},[_c('square-loader',{attrs:{"size":"100px"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }